import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import setCheckoutRuleSessionMutation from './mutation'
import {
  ISetCheckoutRuleSessionResponse,
  ISetCheckoutRuleSessionVariables,
} from './types'

/**
 * Hook declaration to persist a checkout-rule selection onto a session.
 *
 * No `fetchPolicy` — a mutation has no cache read to govern, and the cache
 * holds nothing for this field to write through (`getCheckoutRule` is
 * `no-cache`, and `session.checkoutRules` lives in the redux session
 * snapshot, which `useCheckoutRuleSelection.select` patches itself once this
 * resolves, COM-1765). `acceptCheckoutRule` beside it is declared the same way.
 * @param options: MutationHookOptions
 * @internal
 */
const useSetCheckoutRuleSession = (
  options?: MutationHookOptions<
    ISetCheckoutRuleSessionResponse,
    ISetCheckoutRuleSessionVariables
  >,
): MutationTuple<
  ISetCheckoutRuleSessionResponse,
  ISetCheckoutRuleSessionVariables
> => {
  return useMutation<
    ISetCheckoutRuleSessionResponse,
    ISetCheckoutRuleSessionVariables
  >(setCheckoutRuleSessionMutation, options)
}

export default useSetCheckoutRuleSession
